import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import axios from "axios";
import httpClientReq from "services/httpClient";

function ReturnRefundDetails({ orderId,orderType }) {
  const [order, setOrder] = useState(null);
  const componentRef = useRef();

  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/orders/getReturnRefundOrderDetails?orderId=${orderId}&orderType=${orderType}`
        );
        const data = response?.data?.data?.orderDetails[0];
        setOrder(data);
      } catch (error) {
        console.error("Error fetching order details:", error);
      }
    };

    fetchOrderDetails();
  }, []);

//   const handlePrint = useReactToPrint({
//     content: () => componentRef.current,
//     pageStyle: "padding-20px",
//   });

  return (
    <main ref={componentRef}>
      {order && (
        <section className="grid gap-x-10 grid-cols-1 md:grid-cols-3">
          <div className="flex flex-col gap-4">
            <span className="font-sm text-sm">Customer Name : {order?.customerName}</span>
            <span className="text-sm font-sm">Phone : {order?.phone}</span>
            <span className="text-sm">
              <span className="text-sm font-sm">
                Address Details : {order?.address?.addressDetail}
              </span>
              <br></br>
              <span className="text-sm font-sm">Country : {order?.address?.country}</span>
              <br></br>

              <span className="text-sm font-sm">City : {order?.address?.city}</span>
              <br></br>
              <span className="text-sm font-sm">State : {order?.address?.state}</span>
              <br></br>
            </span>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-sm font-sm">Order Date : {order?.date}</span>
            {/* <span className="text-sm font-sm">Invoice No : {order?.orderId}</span> */}
            <span className="text-sm font-sm">Order No : {order?.orderId}</span>
            {/* <span className="text-sm font-sm">Category Name : {order?.categoriesId}</span> */}
            <span className="text-sm font-sm">Weight: {order?.shuttleWeight}</span>
          </div>
          {/* <div className="flex items-center justify-center">
            <QRCode
              size={120}
              value="welcome to Jumunona"
              style={{ width: "120px", height: "120px" }}
            />
          </div> */}
        </section>
      )}

      {/* list table of products */}
      {order && (
        <section className="mt-4">
          <table className="w-full table-auto">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Image</th>
                <th>Product Name</th>
                <th>Attr 1</th>
                <th>Attr 2</th>
                <th>Store Name</th>
                <th>Mode</th>
                <th>Payment Mode</th>
                <th>Price</th>
                <th>Single Price</th>
                <th>Quantity</th>
                <th>Shipping Fee</th>
                <th>Tax</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {order?.description?.map((item, index) => (
                <tr key={index}>
                  <td>{index+1}</td>
                  <td>
                    <img src={item.productImage} alt="" style={{height:"70px",width:"70px"}} />
                  </td>
                  <td>{item.productName}</td>
                  <td>{item.attr1}</td>
                  <td>{item.attr2}</td>
                  <td>{item.storeName}</td>
                  <td>{item.mode}</td>
                  <td>{item.paymentMethod}</td>
                  <td>{item.price}</td>
                  <td>{item.singlePrice}</td>
                  <td>{item.quantity}</td>
                  <td>{item.shippingFee}</td>
                  <td>{item.tax}</td>
                  <td>{item.total}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* show total payable amount */}
          <div className="flex mt-4 justify-between items-center">
            {/* <button
              onClick={handlePrint}
              className="bg-blue-500 text-white rounded-md border-none outline-none p-2 cursor-pointer"
            >
              Print
            </button> */}
            <div className="flex gap-2">
              <span className="text-md italic font-semibold">Total</span>
              <b className="italic">
                {order?.description?.reduce((acc, item) => acc + item.total, 0) ?? 0}c.
              </b>
            </div>
          </div>
        </section>
      )}
    </main>
  );
}

export default ReturnRefundDetails;
